module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Basic")]), _vm._v(" "), _c('basic-example'), _vm._v(" "), _c('h3', [_vm._v("isError Prop")]), _vm._v(" "), _c('error-prop-example'), _vm._v(" "), _c('h3', [_vm._v("isDisabled Prop")]), _vm._v(" "), _c('disabled-prop-example')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b4a08b5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sample/MultiList/MultiList.vue
// module id = 384
// module chunks = 2